unit Search.TFNDepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.Client, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.Buttons, Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmSearchTFNDepots = class(TWebForm)
    wpMain: TWebPanel;
    WebLabel1: TWebLabel;
    WebPanel1: TWebPanel;
    btnBack: TWebSpeedButton;
    btnSelect: TWebSpeedButton;
    weSearch: TWebEdit;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wdsSearch: TXDataWebDataSet;
    wcSearch: TXDataWebClient;
    dsSearch: TWebDataSource;
    wdsSearchnumber: TIntegerField;
    wdsSearchname: TStringField;
    wdsSearchregion: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
  private
    { Private declarations }
  public
    { Public declarations }
    iNumber : Integer;
    sDepotName : String;
  end;

var
  frmSearchTFNDepots: TfrmSearchTFNDepots;

implementation

{$R *.dfm}
uses
stfmssystem.connection ,  share.common;

procedure TfrmSearchTFNDepots.btnBackClick(Sender: TObject);
begin
  iNumber := 0;
  sDepotName := '';
  Close;
end;

procedure TfrmSearchTFNDepots.btnSelectClick(Sender: TObject);
begin
  close;
end;

procedure TfrmSearchTFNDepots.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iNumber := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sDepotName := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchTFNDepots.WebFormShow(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;

begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_TFNDepots_View',[],@OnSuccess);
end;

end.
